<template>
  <div>
    <form-close-po
      ref="Form"
      :isClosePoValidate="isClosePoValidate"
      :data="dataForm"
      :model="getModel"
      @onAlert="handleAlert"
      @onClosePO="handleClosePo"
      @onAutoSave="mixAutoSave"
    />
    <dialog-alert ref="dialog-alert" :config="alertConfig" />
  </div>
</template>

<script>
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'SectionPOGeneral',
  mixins: [AutoSaveMixin],
  components: {
    'form-close-po': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormClosePo.vue'),
    'dialog-alert': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogAlert')
  },
  created () {
    this.$bus.$onPromise('validate-all-sections', this.validate)
    this.$bus.$onPromise('on-close-po', this.validate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-all-sections', this.validate)
    this.$bus.$offPromise('on-close-po', this.validate)
  },
  props: {
    isClosePoValidate: { type: Boolean, required: true },
    dataSalesOrder: { type: Object }
  },
  computed: {
    alertConfig () {
      return {
        title: this.L10n('alert'),
        text: this.L10n('check-part-in-order')
      }
    },
    dataForm () {
      const { poStillOpen, approvedForPaymentByEmployeeID, paymentRemarks, scoreID } = this.dataSalesOrder
      return {
        scoreID,
        poStillOpen,
        approvedForPaymentByEmployeeID,
        paymentRemarks
      }
    },
    isAvailableToSave () {
      return true
    },
    apiAutoSave () {
      return `SalesOrders/Patch/${this.dataSalesOrder.id}`
    }
  },
  methods: {
    getModel () {
      return {
        scoreID: null,
        poStillOpen: false,
        approvedForPaymentByEmployeeID: null,
        paymentRemarks: ''
      }
    },
    handleClosePo () {
      this.$emit('onClosePO')
    },
    handleAlert () {
      this.$refs['dialog-alert'].show()
    },
    mixSuccessAutoSave (data, settings) {
      this.$emit('update:dataSalesOrder', { ...this.dataSalesOrder, ...data })
    },
    mixErrorAutoSave () {
      this.$emit('update:dataSalesOrder', { ...this.dataSalesOrder })
    },
    validate () {
      return this.$refs.Form.validate()
    }
  }
}
</script>
